import { authHttp } from '../http'
import * as routes from '../../routes/receive-vehicle.routes'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

export async function getVeiculosParaRetorno(tp_id, pInicial, pFinal) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().get(
      routes.urlGetReceiveVehicles(tp_id, pInicial, pFinal, user_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getVeiculosParaRetornoByNF(tp_id, notaFiscal, pInicial, pFinal) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().get(
      routes.urlGetReceiveVehiclesByNF(tp_id, notaFiscal, pInicial, pFinal, user_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getVeiculosParaRetornoByCidade(tp_id, cidade, pInicial, pFinal) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().get(
      routes.urlGetReceiveVehiclesByCidade(tp_id, cidade, pInicial, pFinal, user_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getExportVeiculosParaRetorno(tp_id, fleet_ids) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlGetExportReceiveVehicles(tp_id, user_id), {
      fleet_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getExportVeiculosRetornados(tp_id, fleet_ids) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlGetExportReturnedVehicles(tp_id, user_id), {
      fleet_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getEntregas(fleet_id) {
  try {
    const response = await authHttp().get(routes.urlGetDeliveries(fleet_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function putDeliveriedDate(delivery_event_id, deliveried_date) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().put(routes.urlPutDeliveriedDate(delivery_event_id), {
      deliveried_date,
      user_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postVeiculosComEntregaTotal(tp_id, fleets_ids) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(
      routes.urlPostVehiclesDeliverySucceed(tp_id, user_id),
      fleets_ids,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postEntregasAction(tp_id, deliveries_steps_vehicles_ids, action) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(routes.urlPostEntregasAction(tp_id, user_id), {
      deliveries_steps_vehicles_ids,
      action,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function putRetornarVeiculo(fleets_id, body) {
  try {
    const response = await authHttp().put(routes.urlPutRetornarVeiculo(fleets_id), body)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export function relatorioRetornoVeiculo(deliveriesIds) {
  return routes.urlRelatorioRetornoVeiculo(deliveriesIds)
}

export async function putDeliveryEventAttempt(delivery_event_id, last_attempt_date, last_attempt_justify) {
  try {
    const response = await authHttp().put(routes.urlPutDeliveryEventAttempt(delivery_event_id), {
      last_attempt_date,
      last_attempt_justify,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function putUpdateDeliveryPaths(delivery_id, action, filename) {
  try {
    const response = await authHttp().put(routes.urlUpdateDocPath(delivery_id), {
      action,
      path: filename,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteDeliveryCanhotoFile(filename) {
  try {
    return await authHttp().delete(routes.urlDeleteFileCanhoto(filename))
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteDeliveryNfDevolucaoTotalFile(filename) {
  try {
    return await authHttp().delete(routes.urlDeleteFileNfDevolucaoTotal(filename))
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postAssocNFParcialComFaltas(info, delivery_id) {
  try {
    const response = await authHttp().post(
      routes.urlAssocNfDevolucaoParcialComAsFaltas(delivery_id),
      info,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function putMissingProductQteAdjusted(info) {
  try {
    const response = await authHttp().put(routes.urlPutMissingProductQteAdjusted, info)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getInfoMissingProductStageEntrega(delivery_id) {
  try {
    const response = await authHttp().get(routes.urlGetInfoMissingProductStageEntrega(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postMissingProductStageEntrega(delivery_step_id, info) {
  try {
    const response = await authHttp().post(
      routes.urlPostMissingProductStageEntrega(delivery_step_id),
      { info, ignorar_status_entrega: true },
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postExcelMultipleApuracao(tp_id, content) {
  try {
    const response = await authHttp().post(routes.urlApuracaoRetornoVeiculoEntrega(tp_id), content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getEntregasParaApurar(tp_id) {
  try {
    return routes.urlGetEntregasParaApurar(tp_id)
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getLeftoverProductByFleetId(fleet_id) {
  try {
    const response = await authHttp().get(routes.urlLeftoverProductByFleetId(fleet_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getLeftoverProductInfoByCompanyId(company_id) {
  try {
    const response = await authHttp().get(routes.urlLeftoverProductInfoByCompanyId(company_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postLeftoverProducts(content) {
  try {
    const response = await authHttp().post(routes.urlLeftoverProduct(), content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function putLeftoverProductQteAdjusted(id, info) {
  try {
    const response = await authHttp().put(routes.urlLeftoverProductAjust(id), info)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getReturnedVehicles(tp_id, dataInicio, dataFim) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().get(
      routes.urlGetReturnedVehicles(tp_id, dataInicio, dataFim, user_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getReturnedVehiclesByNF(tp_id, dataInicio, dataFim, notaFiscal, company_id) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().get(
      routes.urlgetReturnedVehiclesByNF(
        tp_id,
        dataInicio,
        dataFim,
        notaFiscal,
        company_id,
        user_id,
      ),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getVehiclesInfo(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetVehiclesInfo(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
